<template>
  <el-card>
    <el-tabs v-model="activeTab" @tab-click="fetchAll">
      <el-tab-pane label="ALL" name="ALL" :lazy="true"></el-tab-pane>
      <el-tab-pane label="TM"  name="TM" :lazy="true"> </el-tab-pane>
      <el-tab-pane label="STI" name="STI" :lazy="true"></el-tab-pane>
      <el-tab-pane label="未啟用" name="disable" :lazy="true"></el-tab-pane>
    </el-tabs>

    <el-table
      v-if="filteredRows.length > 0"
      :data="filteredRows"
      border
      style="width: 100%"
    >
      <el-table-column prop="name" label="Name" />
      <el-table-column prop="_id" label="_id" />
      <el-table-column prop="isAlertDisable" label="啟用狀態" >
        <template slot-scope="scope">
          <el-tag :type="scope.row.isAlertDisable ? 'danger' : 'success'">
            {{ scope.row.isAlertDisable ? '已關閉' : '啟用中' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="TYPE">
        <template slot-scope="scope">
          {{ activeTab === 'disable' ? scope.row.disabledTypeList : scope.row.usedTypeList }}
        </template>
      </el-table-column>
      <el-table-column label="Target Group">
        <template slot-scope="scope">
          <span
            v-for="(g, i) in scope.row.targetsGroup"
            :key="i"
          >{{ g }}<span v-if="i < scope.row.targetsGroup.length - 1">, </span></span>
          <span v-if="!scope.row.targetsGroup || !scope.row.targetsGroup.length">—</span>
        </template>
      </el-table-column>
    </el-table>
  </el-card>
</template>

<script>
export default {
  props: {
    instrumentList: {
      type: Array,
      required: true,
    },
    project: {
      required: true,
    },
  },
  data(){
    return {
      activeTab: 'ALL',
      advInstrumentList: [],
      filteredRows: [],
      alertGroupMap: {},
    };
  },
  async mounted(){
    await this.fetchAlertGroups();
    this.initInstrumentList(this.instrumentList);
  },
  methods: {
    async fetchAlertGroups(){
      try {
        const res = await this.$axios({
          category: 'alerts',
          method: 'get',
          apiName: 'getAllAlertGroup',
        });
        this.alertGroupMap = Object.fromEntries(
          res.data.map(g => [g._id, g]),
        );
      } catch(e) {
        console.error('fetchAlertGroups error', e);
      }
    },

    initInstrumentList(instrumentList){
      console.log(instrumentList);
      this.advInstrumentList = instrumentList.map(ele=>{
        const advanced_alert = this.advancedAlert(ele.advanced_alert);
        return {
          _id: ele._id,
          name: ele.latestVersion.name,
          used_advanced_alert: advanced_alert,
          isAlertDisable: advanced_alert?.isAlertDisable,
          usedTypeList: advanced_alert?.usedTypeList || '',
          disabledTypeList: advanced_alert?.disabledTypeList || '',
          targetsGroup: advanced_alert?.targetsGroup || [],
        };
      }).filter(ins => ins.used_advanced_alert);
      this.fetchAll();
    },

    advancedAlert(advanced_alert){
      if(!Array.isArray(advanced_alert) || !advanced_alert.length) return null;
      // 只要有任一條規則未啟用即算「未啟用」；「未啟用」頁籤的 TYPE 欄改看 disabledTypeList，其他頁籤仍看 usedTypeList
      const disabledItems = advanced_alert.filter(item => !item.active);
      const result = {
        isAlertDisable: disabledItems.length > 0,
        usedTypeList: advanced_alert.map(item => item.rule).join(' | '),
        disabledTypeList: disabledItems.map(item => item.rule).join(' | '),
        targetsGroup: advanced_alert
          .map(item => {
            const group = this.alertGroupMap[item.targetsGroup];
            return group ? group.notes : item.targetsGroup;
          })
          .filter(v => v != null),
      };

      return result;
    },

    fetchAll(){
      if(this.activeTab == 'ALL') return this.filteredRows = this.advInstrumentList;
      if(this.activeTab == 'disable') return this.filteredRows = this.advInstrumentList.filter(ele=>ele.isAlertDisable);
      
      this.filteredRows = this.advInstrumentList.filter(ele=>{
        return ele.name.includes(this.activeTab);
      });
    },
  },
};
</script>